import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './Banner.css';

const Banner = () => {
  const [bannerUrl, setBannerUrl] = useState('');
  const API_URL = api.defaults.baseURL.replace('/api', '');

  useEffect(() => {
    // Ambil URL banner yang aktif dari backend
    api.get('/banner/active')
      .then(res => {
        if (res.data && res.data.imageUrl) {
          setBannerUrl(`${API_URL}/${res.data.imageUrl}`);
        }
      })
      .catch(err => console.error("Gagal memuat banner:", err));
  }, [API_URL]); // <-- Tambahkan API_URL di sini

  const bannerStyle = {
    backgroundImage: `url(${bannerUrl})`,
  };

  return (
    <div className="banner-container" style={bannerUrl ? bannerStyle : {}}>
      <div className="banner-content">
      </div>
    </div>
  );
};

export default Banner;